// Shared category-filter behaviour for the theme's card grids. Filter tags show/hide items by
// data-category client-side; an optional "Learn more" reveals hidden items.
export default function initFilterGrid({ rootSelector, tagSelector, itemSelector, moreSelector, emptyText, afterInit }) {
  const root = document.querySelector(rootSelector);
  if (!root) return;

  const tags = Array.from(root.querySelectorAll(tagSelector));
  const items = Array.from(root.querySelectorAll(itemSelector));
  const moreBtn = moreSelector ? root.querySelector(moreSelector) : null;
  if (!tags.length || !items.length) return;

  let activeFilter = 'all';
  const grid = items[0].parentElement;
  let emptyEl = null;

  function matchesFilter(item) {
    return activeFilter === 'all' || (item.dataset.category || '').split(' ').includes(activeFilter);
  }

  function showEmpty(show) {
    if (show && !emptyEl) {
      emptyEl = document.createElement('p');
      emptyEl.className = 'kd-grid-empty';
      emptyEl.setAttribute('role', 'status');
      grid.insertAdjacentElement('afterend', emptyEl);
    }
    if (!emptyEl) return;
    emptyEl.hidden = !show;
    if (show) {
      const label = (tags.find((t) => t.classList.contains('is-active')) || {}).textContent || '';
      emptyEl.textContent = typeof emptyText === 'function'
        ? emptyText(label.trim())
        : (emptyText || 'Nothing here yet — try another filter.');
    }
  }

  // Only toggles display on already-"revealed" items (no .is-hidden class);
  // items past the initial page stay untouched until "Learn more" reveals them.
  // A narrowed filter reveals its matches so a match can never hide behind pagination.
  function applyFilter() {
    let visible = 0;

    items.forEach((item) => {
      const matches = matchesFilter(item);
      if (activeFilter !== 'all' && matches) item.classList.remove('is-hidden');
      if (item.classList.contains('is-hidden')) return;
      item.style.display = matches ? '' : 'none';
      if (matches) visible += 1;
    });

    showEmpty(visible === 0);
  }

  tags.forEach((tag) => {
    tag.addEventListener('click', () => {
      if (tag.classList.contains('is-active')) return;
      tags.forEach((t) => t.classList.remove('is-active'));
      tag.classList.add('is-active');
      activeFilter = tag.dataset.filter || 'all';
      applyFilter();
    });
  });

  if (moreBtn) {
    moreBtn.addEventListener('click', () => {
      items.forEach((item) => item.classList.remove('is-hidden'));
      moreBtn.parentElement.style.display = 'none';
      applyFilter();
    });
  }

  applyFilter();

  if (afterInit) afterInit(root);
}
